import React from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { OutlinedPrimaryButton } from "../../components/ui/Button";
import { useSelector } from "react-redux";
import { authSelector } from "../../services/redux/slices/authSlice";
import { decrypt } from "../../utils/crypto";
import { trackCustomerJourneyEvent } from "../../utils/ga";

interface DashboardJournyProps {
  activeTab?: "new" | "existing";
}

const DashboardJourny: React.FC<DashboardJournyProps> = ({
  activeTab = "new",
}) => {
  const navigate = useNavigate();
  const { userProfile, isAuthenticated } = useSelector(authSelector);
  const userId = decrypt(userProfile?.id) ?? "";

  return (
    <div className="dashboard-container">
      <Box sx={{ flex: 1, width: "90%" }}>
        <Box sx={{ mb: 2, mt: 1, display: "flex", gap: 1 }}>
          {/* <OutlinedPrimaryButton
            width="150px"
            height="45px"
            border={`1px solid ${activeTab === "new" ? "#00B3B5" : "#d9d9d9"}`}
            borderRadius="999px"
            backgroundColor={activeTab === "new" ? "#e5feffff" : "#ffffff"}
            textColor={activeTab === "new" ? "#00B3B5" : "#999797ff"}
            onClick={() => {
              trackCustomerJourneyEvent(
                "Postlogin_Newapplication",
                userId,
                "",
                {
                  label: "Postlogin_Newapplication",
                  category: "Postlogin_Newapplication",
                  action: "Postlogin_Newapplication",
                  page: "Post Login New Application Button ",
                }
              );
              navigate("/application");
            }}
            sx={{ pointerEvents: "auto", cursor: "pointer" }}
          >
            New Application
          </OutlinedPrimaryButton> */}
          <OutlinedPrimaryButton
            width="150px"
            height="45px"
            border={`1px solid ${activeTab === "existing" ? "#00B3B5" : "#d9d9d9"
              }`}
            borderRadius="999px"
            backgroundColor={activeTab === "existing" ? "#e5feffff" : "#ffffff"}
            textColor={activeTab === "existing" ? "#00B3B5" : "#999797ff"}
            onClick={() => {
              trackCustomerJourneyEvent(
                "Postlogin_Existingapplication",
                userId,
                "",
                {
                  label: "Postlogin_Existingapplication",
                  category: "Postlogin_Existingapplication",
                  action: "Postlogin_Existingapplication",
                  page: "Post Login Existing Application Button ",
                }
              );
              navigate("/application/existing-application");
            }}
            sx={{ pointerEvents: "auto", cursor: "pointer" }}
          >
            Existing Application
          </OutlinedPrimaryButton>
        </Box>
      </Box>
    </div>
  );
};

export default DashboardJourny;
